/**
 * Created by marenkoehler on 31.07.17.
 */
import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.IframeLoader = function (element, consent) {
        this.$wrapper = $(element);
        this.$iframe = $('iframe', this.$wrapper);
        this.consent = consent;

        this.init();
    };

    OndigoNS.IframeLoader.prototype = {
        init: function () {
            if(this.$wrapper.data('type') === 'myonoffice') {

                if(OndigoNS.Usercentrics.myonofficeAllowed(this.consent)) {
                    this.loadIframe(true);
                } else {
                    this.loadIframe(false);
                }
            }

            if(this.$wrapper.data('type') === 'ogulo') {

                if(OndigoNS.Usercentrics.oguloAllowed(this.consent)) {
                    this.loadIframe(true);
                } else {
                    this.loadIframe(false);
                }
            }
        },

        loadIframe : function (init) {

            if(init) {

                if(this.$iframe.data('src') !== undefined && (this.$iframe.attr('src') === undefined || this.$iframe.attr('src') === '')) {
                    this.$iframe.attr('src', this.$iframe.data('src'));

                    OndigoNS.Usercentrics.myonofficeRemoveOverlay(this.$wrapper, this.consent);
                    OndigoNS.Usercentrics.oguloRemoveOverlay(this.$wrapper, this.consent);
                }
            } else {
                this.$iframe.attr('src', '');

                OndigoNS.Usercentrics.myonofficeShowOverlay(this.$wrapper, this.consent);
                OndigoNS.Usercentrics.oguloShowOverlay(this.$wrapper, this.consent);
            }
        }
    };
    // plugin definition
    $.fn.initIframeLoader = function (e) {
        return new OndigoNS.IframeLoader(this, e);
    };
    $.fn.initIframeLoader.Constructor = OndigoNS.IframeLoader;

}(window.jQuery));

$(document).ready(function () {
    'use strict';

    var $wrapper = $('.iframe-wrapper');
    if ($wrapper.length) {

        $.each($wrapper, function () {
            $(this).initIframeLoader(false);
        });
    }

    window.addEventListener('ucEvent', function (e) {
        if ($('.iframe-wrapper').length) {

            $.each($('.iframe-wrapper'), function () {
                $(this).initIframeLoader(e);
            });
        }
    });
});